module.exports = __webpack_public_path__ + "img/vallicon_avatar.d39e14dc.png";